import { Stack, Text, Paper, Grid, Table, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { StereoAcuityTestResult } from "types/testTypes";
import StereoAcuityTimeChart from "@components/testContainer/common/StereoAcuityTimeChart";

export default function StereoAcuityTestEntry({ entry }) {
  const { t } = useTranslation();
  const testResults = entry as StereoAcuityTestResult;

  // Calculate success rate

  if (!testResults) {
    return <Text>{t("common.noDataAvailable")}</Text>;
  }

  return (
    <Stack gap="md" mb="md">
      <Grid gutter="md">
        <Grid.Col span={12}>
          <StereoAcuityTimeChart stereoAcuityDatas={testResults.results.responses} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Paper p="md" radius="md" withBorder>
            <Title order={4} mb="md">
              {t("extraTests.stereoAcuity.scoresTitle")}
            </Title>
            <Table striped highlightOnHover withTableBorder>
              <Table.Tbody>
                <Table.Tr>
                  <Table.Th>{t("extraTests.stereoAcuity.csdScore")}</Table.Th>
                  <Table.Td>{testResults.results.csdScore.toFixed(2)}</Table.Td>
                </Table.Tr>
              </Table.Tbody>
            </Table>
          </Paper>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
